import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    draft:'',
    responsePush:{},
    errorMsj: '',
    infoRP: [],
    responsibles: [],
    files: [],
    infoForum: [],
    stateProcess: 0,
    linkProccess: 0,
    infoRPl: [],
    evidences: [],
    informerInfo: [],
    loading: false,
    headerLetter: '',
    footerLetter: '',
    dashboard: [],
    answers: [],
    bpSignature: {}
  },
  getters: {},
  mutations: {
    setInfoRP: (state, infoRP) => {
      state.infoRP = infoRP;
    },
    setResponsibles: (state, responsibles) => {
      state.responsibles = responsibles;
    },
    setFiles: (state, files) => {
      state.files = files;
    }, 
    setInfoForum: (state, infoForum) => {
      state.infoForum = infoForum;
    },
    setStateProcess: (state, stateProcess) => {
      state.stateProcess = stateProcess;
    },
    setInfoRPl: (state, infoRPl) => {
      state.infoRPl = infoRPl;
    },
    setEvidences: (state, evidences) => {
      state.evidences = evidences;
    },
    setLinkProccess: (state, linkProccess) => {
      state.linkProccess = linkProccess;
    }, 
    setInformerInfo: (state, informerInfo) => {
      state.informerInfo = informerInfo;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
    setHeader: (state, headerLetter) => {
      state.headerLetter = headerLetter;
    },
    setFooter: (state, footerLetter) => {
      state.footerLetter = footerLetter;
    },
    setDashboard: (state, dashboard) => {
      state.dashboard = dashboard;
    },
    setAnswers: (state, answers) => {
      state.answers = answers;
    },
    responsePush:(state, response) =>{
      state.responsePush = response
    },
    setBpSignature:(state, response) =>{
      state.bpSignature = response
    },
    setDraft:(state,response) =>{
      state.draft = response
    }
  },
  actions: {    
    //Trae la informacion del derecho de peticion
    actGetInfoRP: async ({
      commit
    }, id) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getInfoRP(id);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setInfoRP', response);
        }
        return true;
    },

    //Trae la informacion de los responsables de los derechos de peticion
    actGetResponsibles: async ({
      commit
    }, id) => {
        let response = await ApiPermisos.getResponsibles(id);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setResponsibles', response);
        }
        return true;
    },

    // Guarda info asociada a un derecho de petición
    actSaveInfoRP: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.saveInfoRP(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Adiciona participante al foro
    actAddUserForum: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.addUserForum(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    //Trae archivos asociados al Derecho peticion
    actGetfiles: async ({
      commit
    }, id) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getfiles(id);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setFiles', response);
        }
        return true;
    },

    // Envia respuesta del DP
    actSendResponse: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      commit('setLoading', true);
      let response = await ApiPermisos.sendResponse(id,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    //Trae informacion del Foro
    actGetInfoForum: async ({
      commit
    }, id) => {
        let response = await ApiPermisos.getInfoForum(id);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setInfoForum', response);
        }
        return true;
    },

    // Envia comentario padre al foro
    actSendComment: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      commit('setLoading', true);
      let response = await ApiPermisos.sendComment(id,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Envia archivo al foro
    actSendFilesForum: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      commit('setLoading', true);
      let response = await ApiPermisos.sendFilesForum(id,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Listar evidencias del DP
    actGetEvidencesRP: async ({
      commit
    }, id) => {
        let response = await ApiPermisos.getEvidencesRP(id);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setEvidences', response);
        }
        return true;
    },

    // Guarda evidencia
    actSaveEvidenceRP: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      commit('setLoading', true);
      let response = await ApiPermisos.saveEvidenceRP(id,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Guarda evidencia
    actSendRequestBP: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.sendRequestBP(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Carga toda la información del rol informador
    actGetInformerInfo: async ({
      commit
    }, email) => {
        let response = await ApiPermisos.getInformerInfo(email);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setInformerInfo', response);
        }
        return true;
    },

    // Borra archivo del foro
    actDeleteFileForum: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      commit('setLoading', true);
      let response = await ApiPermisos.deleteFileForum(id,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Borra archivo evidencia DP
    actDeleteFileEvidence: async ({
      commit
    }, id) => {
      commit('setLoading', true);
      let response = await ApiPermisos.deleteFileEvidence(id);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Actualiza el estado de Foro
    actPutStatusForum: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.putStatusForum(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    // Carga informacion del Dashboard
    actGetDashboardRP: async ({
      commit
    }, year) => {
        let response = await ApiPermisos.getDashboardRP(year);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setDashboard', response);
        }
        return true;
    }, 

    actSendPush: async ({
      commit
    }, id) => {
        let response = await ApiPermisos.sendPush(id);
        if (response.error) {
          commit('errorMsj', response);
          return response.error;
        }
        else{
          commit('responsePush', response);
          
        }
    }, 

    actDeleteFileRes: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.deleteFileRes(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    }, 

    actUploadFileRes: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.uploadFileRes(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    }, 

    actRecategorize: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      let response = await ApiPermisos.recategorize(id,params);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    actGetAnswers: async ({
      commit
    }, id) => {
      let response = await ApiPermisos.getAnswers(id);
      if (response.error) {
          return response.error;
      }
      else{
        commit('setAnswers', response);
      }
      return true;
    },  

    actSetStatusUserFrm: async ({
      commit
    }, data) => {
      let id = data[0];
      let params = data[1];
      commit('setLoading', true);
      let response = await ApiPermisos.setStatusUserFrm(id,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    actValidateUserFrm: async ({
      commit
    }, data) => {
      let idDP = data[0];
      let idForum = data[1];
      let params = data[2];
      commit('setLoading', true);
      let response = await ApiPermisos.validateUserFrm(idDP,idForum,params);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },

    //Elimina Evidencias de respuesta temporal

    actDeleteFileTemporalEvidence: async ({
      commit
    }, id) => {
      try{
        commit('setLoading', true);
        await ApiPermisos.deleteFileTemporalEvidence(id);
        commit('setLoading', false);
      }catch(error){
        console.log(error)
      }
    },

    //Agrega firma del BP a la respuesta

    actSetSignatureBP: async ({
      commit
    }, id) => {
      try{
        let bp = await ApiPermisos.getProfile(id);
        let response = {
          'name': bp.data.name,
          'signature': bp.data.signature
        }
        commit('setBpSignature', response);
      }catch(error){
        console.log(error)
      }
    },

    actSaveDataPhisicalResponse: async ({
      commit
    }, data) => {
      try{
        commit('setLoading', true);
        let id = data[0];
        let params = data[1];
        ApiPermisos.actPhisicalResponse(id,params);
        commit('setLoading', false);
      }catch(error){
        console.log(error)
      }
    },

    setDraft: async ({
      commit
    },id) => {
      try{
        let res = await ApiPermisos.getDraft(id);
        let response = ""
        if(res.data === null){
          response = ""
        }else{
          response = res.data.letter
        }
        commit('setDraft', response);
      }catch(error){
        console.log(error)
      }
    }
    
  },
}